module.exports = __webpack_public_path__ + "img/coffee-cup.c62f6319.svg";